import React, { useState, useEffect, useRef } from "react";
import API from "../api";
import { Avatar, Select, message } from "antd";
import {
  UserOutlined,
  SearchOutlined,
  CloseSquareOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import style from "./topHeader.module.scss";
import Logo from "../assests/logo.svg";
import { storage } from "../utils/storage";
import useIsMobile from "../utils/useIsMobile";
import { antdMessageError } from "../utils/antdMessageComponent";

const TopHeader = ({
  isPartner,
  setCollapsed,
  collapsed,
  currentKey,
}: {
  isPartner?: boolean;
  setCollapsed?: any;
  collapsed?: boolean;
  currentKey: string;
}) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const authDetails = storage.getAuthDetails();
  const ref = useRef<any>(null);

  const [openMenu, setOpenMenu] = useState(false);
  const [stationData, setStationData] = useState<any[]>([]);
  const [showSearch, setShowSearch] = useState(false);

  const defaultVal = storage.getSelectedStation().name;

  useEffect(() => {
    const fetchStations = async () => {
      const stations = await API.partner.GetStations({ _id: authDetails._id });
      if (!API.validators.checkSuccessCode(stations))
        return message.error("Unable to fetch stations");

      const data = stations.data?.data || [];
      setStationData(data);

      if (!storage.getSelectedStation().id && data.length) {
        storage.setSelectedStation({
          id: data[0]._id,
          name: data[0].name,
        });
      }
    };

    if (isPartner) fetchStations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (!ref.current?.contains(e.target)) setOpenMenu(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    const logoutFn = isPartner ? API.auth.PartnerLogout : API.auth.AdminLogout;

    const res = await logoutFn({ sessionId: authDetails.sessionId || "" });
    if (!API.validators.checkSuccessCode(res)) {
      return antdMessageError("Unable to logout");
    }

    storage.clearAuthDetails();
    if (isPartner) storage.clearSelectedStation();
    navigate(isPartner ? "/partner" : "/admin");
  };

  const StationSelectBox = () => (
    <Select
      placeholder="Search Station"
      value={defaultVal}
      className={style["select-box-for-header"]}
      onChange={(value) => {
        const [id, name] = value.split("++");
        storage.setSelectedStation({ id, name });
        setShowSearch(false);
        window.location.reload();
      }}
      showSearch
      style={{ flex: 1 }}
    >
      {stationData.map(({ _id, name }) => (
        <option key={_id} value={`${_id}++${name}`}>
          {name}
        </option>
      ))}
    </Select>
  );

  return (
    <div className={style["container"]}>
      {/* Hamburger Menu & Logo */}
      <div className={style["left-container"]}>
        {isMobile && (
          <MenuOutlined
            className={style["hamburger-menu"]}
            onClick={() => setCollapsed?.(!collapsed)}
            onPointerEnterCapture={() => {}}
            onPointerLeaveCapture={() => {}}
          />
        )}
        <img
          src={Logo}
          className={style["logo-img"]}
          alt="logo"
          style={{ cursor: "default" }}
        />
      </div>

      {isMobile ? (
        <>
          {/* Mobile Header */}
          {showSearch ? (
            <div
              className={`${style["mobile-search-slide"]} ${
                showSearch ? style["open"] : ""
              }`}
            >
              <div className={style["search-header"]}>
                <StationSelectBox />
                <CloseSquareOutlined
                  className={style["close-btn"]}
                  onClick={() => setShowSearch(false)}
                  onPointerEnterCapture={() => {}}
                  onPointerLeaveCapture={() => {}}
                />
              </div>
            </div>
          ) : (
            <div className={style["right-container"]}>
              <div className={style["page-title"]}>{currentKey}</div>
              <Avatar
                icon={
                  <UserOutlined
                    onPointerEnterCapture={() => {}}
                    onPointerLeaveCapture={() => {}}
                  />
                }
                style={{ backgroundColor: "#87d068" }}
                onClick={() => setOpenMenu(!openMenu)}
              />
              {isPartner && (
                <SearchOutlined
                  className={style["search-icon"]}
                  onClick={() => setShowSearch(true)}
                  onPointerEnterCapture={() => {}}
                  onPointerLeaveCapture={() => {}}
                />
              )}
            </div>
          )}
        </>
      ) : (
        <>
          {/* Desktop Header */}
          <div className={style["middle-container"]}>
            <div className={style["page-title"]}>{currentKey}</div>
          </div>
          <div className={style["right-container"]}>
            {isPartner && <StationSelectBox />}
            <Avatar
              icon={
                <UserOutlined
                  onPointerEnterCapture={() => {}}
                  onPointerLeaveCapture={() => {}}
                />
              }
              style={{ backgroundColor: "#87d068" }}
              onClick={() => setOpenMenu(!openMenu)}
            />
          </div>
        </>
      )}

      {/* Dropdown Menu */}
      {openMenu && (
        <div className={style["menu-container"]} ref={ref}>
          <div className={style["client-name"]}>
            {isPartner ? "Partner" : "Admin"}
          </div>
          <div className={style["client-title"]}>
            {authDetails.userName || "Client Name"}
          </div>
          <div className={style["items"]} onClick={handleLogout}>
            Logout
          </div>
        </div>
      )}
    </div>
  );
};

export default TopHeader;
